import { isDev, isEnvMocked } from 'src/app/utils/environment';

import { setSeekId } from './utils';

const devSeekIdMappings: Record<string, number> = {
  /*
   * 1000 hirers verified/unverified variations
   */
  '1': 13, // AU hirer: Bus. address unverified & email  both verified
  '2': 13, // AU hirer: Bus. address unverified & email verified
  '1000': 10, // AU hirer: Bus. address & email unverified
  '1100': 10, // AU hirer: Bus. address verified & email unverified
  '1200': 13, // AU hirer: Bus. address unverified & email verified
  '1300': 13, // AU hirer: Bus. address & email both verified
  '1400': 16, // NZ hirer: Bus. address & email both verified
  '1500': 99, // AU hirer: SSO verified / AdCenter unverified (Silent verification)
  '1600': 15, // AU hirer: Pay per outcome product (CPQA experiment)
  '1700': 18, // AU hirer: 4 choice Ad Ladder (Mid Tier experiment)
  '1900': 1900, // AU hirer: Pay&Post V2 experiment
  /*
   * 2000 hirers with custom features enabled
   */
  '2000': 17, // AU hirer: On credit hold
  '2100': 70, // AU hirer: Private advertiser with Branded ad
  '2200': 40, // AU hirer: Hide price enabled
  '2300': 40, // NZ hirer: Hide price enabled
  '2400': 75, // AU hirer: Private advertiser with classic ad
  '2500': 90, // AU hirer: Hidden salary enabled
  /*
   * 3000 hirers on contracts or budgets
   */
  '3000': 20, // AU hirer: Has branded budget
  '3100': 19, // AU hirer: Has contract balance
  '3200': 19, // AU hirer: Has contract balance and access to new Pay And Post Page
  /*
   * 4000 hirers with hirer type based features. e.g gov/recruiter
   */
  '4000': 30, // AU hirer: Linkout to external website enabled
  '4100': 50, // AU hirer: Has agents
  '4200': 60, // AU hirer: Government
  '4300': 80, // AU hirer: Government with set ad expiry (edit flow)
  '4400': 31, // AU hirer: Linkout to SEEK site with RR questionnaire
  '4500': 32, // AU hirer: Linkout to SEEK site with NO RR questionnaire
  /*
   * 5000 hirers from different nations (SEEK and non-SEEK) e.g. AU, MY, UK
   */
  '5000': 21, // ID hirer: Bus. address & email both verified
  '5100': 22, // UK hirer: Bus. address & email both verified
  '5300': 24, // HK hirer: Bus. address & email both verified
  /*
   * 6000 hirers for Talent Search approvals
   */
  '6100': 61, // AU hirer: TalentSearch approved hirer
  '6200': 62, // NZ hirer: TalentSearch approved hirer
};

const setLocalSeekId = () => {
  if (isDev() && isEnvMocked()) {
    const searchParams = new URLSearchParams(
      window.location.search.toLowerCase(),
    );
    const advertiserId = searchParams.get('advertiserid') ?? '1';
    const seekAdvertiserId =
      searchParams.get('seekadvertiserid') ?? devSeekIdMappings[advertiserId];

    setSeekId(seekAdvertiserId.toString());
  }
};

export default setLocalSeekId;
